export const GET_MAP_DATA_SUCCESS = 'GET_MAP_DATA_SUCCESS';
